import { ValidationPatterns } from './validation';

export const CommonPatterns: ValidationPatterns = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phoneGeneric: /^(?:$|(?:\+\d{1,4}\s)?(?=(?:\D*\d){6,15}\D*$)[0-9](?:[0-9 ()-]*[0-9])?)$/,
  loadNumber: /^[a-zA-Z0-9\u4E00-\u9FFF-]*$/u,
  onlyNumber: /^[0-9]+$/,
  onlyLetters: /^[\p{L}]+(?:[ \-'][\p{L}]+)*$/u,
  vehicleId: /^\s*^[A-Z0-9ÄÜÖ\\\-\u4E00-\u9FFF]*$/u,
  humanName: /^[\p{L}\p{M}]+\.?(?:[ \-'][\p{L}\p{M}]+\.?)*$/u,
  decimalNumber: /^[0-9]+([.,][0-9]+)?$/,
  exactly18Characters: /^.{18}$/,
  ssccId: /^[0-9]{3,10}$/,
  compartmentSsccId: /^[0-9]{4}$/,
};
